import { sendClick } from 'reaxl-analytics';

const newsReviewsAnalytics = {

    fireReaxlArticleClick(event, data) {
        sendClick('researchArticleClick', event, data);
    },

    fireReaxlStyleReviewsClick(event, data) {
        sendClick('styleReviewsLinkClick', event, data);
    },

    fireReaxlBtnCTAClick(event, data) {
        sendClick('researchBtnCTAClick', event, data);
    },
};
export default newsReviewsAnalytics;
